import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { ApiAuditLog } from '@/lib/adapters/activity';
import { toLocalDateParam } from '@/lib/dates';

interface DashboardMetrics {
  clients: { total: number; active: number };
  tasks: {
    total: number;
    pending: number;
    inProgress: number;
    inReview: number;
    completed: number;
    archived: number;
    overdue: number;
  };
  users: { total: number };
}

/**
 * Overdue is counted by calendar day, and the API does not know the viewer's timezone, so the
 * viewer's local date goes in `today`. It is part of the query key, so the metrics refetch at midnight.
 */
export function useDashboardMetrics() {
  const today = toLocalDateParam(new Date());
  return useQuery({
    queryKey: ['dashboard', 'metrics', today],
    queryFn: () => api.get<DashboardMetrics>(`/dashboard/metrics?today=${today}`),
  });
}

export function useDashboardActivity(limit = 20) {
  return useQuery({
    queryKey: ['dashboard', 'activity', limit],
    queryFn: () => api.get<{ data: ApiAuditLog[] }>(`/dashboard/activity?limit=${limit}`),
  });
}
